module.exports = __webpack_public_path__ + "static/media/Mattm.f30c07ac.png";